const baseTable = [
  { tableNane: '实际', tableName: 'actual_load_unload_result_stream' },
  // { tableNane: '计划', tableName: 'route_plan_result_stream' },
  { tableNane: '规划', tableName: 'route_plan_optimal_result_stream' },
  { tableNane: '重算', tableName: 'route_plan_result_stream' },
]

export default baseTable
